import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux'
import {Head, UserCreate, UserEdit, UserPassword} from "../../components";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import SyncIcon from '@mui/icons-material/Sync';
import {roleAction, userAction} from "../../actions";
import {Box, Tooltip} from "@mui/material";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import SortIcon from '@mui/icons-material/Sort';
import Chip from "@mui/material/Chip";
import moment from 'moment-jalaali'
import './style.css'
import MenuItem from '@mui/material/MenuItem';
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import Api from "../../utils/api";
import {toast} from "react-toastify";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionActions from "@mui/material/AccordionActions";
import ReactPaginate from "react-paginate";

const Users = ({ fetchUsers, users, roles, fetchRoles, authReducer }) => {

    const [page, setPage] = useState(1);
    const [sort_field, setSortField] = useState('id');
    const [sort_type, setSortType] = useState('desc');
    const [limit, setLimit] = useState(10);
    const [filter, setFilter] = useState({});
    const [searchTime, setSearchTime] = useState("");

    useEffect(() => {
        fetchRoles();
    }, [])

    useEffect(() => {
        handleRequest();
    }, [sort_field, sort_type, limit, filter, page]);


    const handleChangeSearchInput = (event) => {

        let search = filter;
        search[event.target.name] = event.target.value;


        if (searchTime) {
            clearTimeout(searchTime)
        }
        let loop = setTimeout(()=>{


            setFilter({...search})

        },500);

        setSearchTime(loop);




    }


    const handleRequest = () => {
        fetchUsers({
            filter,
            sort_field: sort_field,
            sort_type: sort_type,
            page: page,
            limit: limit
        })
    };

    const handleChangeStatue = (id) => {
        new Api().put(`/users/${id}/status`).then((response) => {
            if (typeof response !== "undefined") {
                if (response.status) {
                    handleRequest()
                } else {
                    toast.error(response.msg);
                }
            }
        })
    }

    if (!users) {
        return false
    }
    const pageCount = Math.ceil(parseInt(users.users.total) / parseInt(users.users.per_page));

    return(
        <Container>
            <Head data={{ 'link': '/', 'title': 'مدیریت کاربران', 'description': 'کاربران را مدیریت کنید' }} />
            <Box mb={5}>
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1c-content"
                        id="panel1c-header"
                    >
                        <div>
                            <Typography>جستجو در لیست</Typography>
                        </div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4} md={3}>
                                <TextField
                                    id="outlined-name"
                                    label="نام کاربر"
                                    variant="outlined"
                                    margin="dense"
                                    fullWidth
                                    name="name"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={handleChangeSearchInput}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <TextField
                                    id="outlined-family"
                                    label="نام خانوادگی کاربر"
                                    variant="outlined"
                                    margin="dense"
                                    fullWidth
                                    name="family"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={handleChangeSearchInput}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <TextField
                                    label="موبایل"
                                    variant="outlined"
                                    margin="dense"
                                    fullWidth
                                    name="mobile"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={handleChangeSearchInput}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <TextField
                                    label="ایمیل"
                                    variant="outlined"
                                    margin="dense"
                                    fullWidth
                                    name="email"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={handleChangeSearchInput}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <TextField
                                    label="username"
                                    variant="outlined"
                                    margin="dense"
                                    fullWidth
                                    name="username"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={handleChangeSearchInput}
                                />
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <TextField
                                    select
                                    label="نقش"
                                    variant="outlined"
                                    value={filter.role_id}
                                    margin="dense"
                                    fullWidth
                                    name="role_id"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={handleChangeSearchInput}
                                >
                                    <MenuItem key={0} value={0}>
                                        انتخاب
                                    </MenuItem>
                                    {roles?.data?.map((role, index) => (
                                        <MenuItem key={index} value={role.id}>
                                            {role.title || role.id}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={4} md={3}>
                                <TextField
                                    select
                                    label="وضعیت"
                                    variant="outlined"
                                    value={filter.status}
                                    margin="dense"
                                    fullWidth
                                    name="status"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={handleChangeSearchInput}
                                >
                                    <MenuItem key={0} value={-1}>
                                        انتخاب
                                    </MenuItem>
                                    <MenuItem key={1} value={1}>
                                        فعال
                                    </MenuItem>
                                    <MenuItem key={2} value={0}>
                                        غیرفعال
                                    </MenuItem>
                                </TextField>
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                    <Divider />
                    <AccordionActions>
                        <Button color="primary">جستجو</Button>
                    </AccordionActions>
                </Accordion>
            </Box>
            <Box mb={2}>
                <Grid container alignItems="center" >
                    <Grid item xs={4} sm={6}>
                        <TextField
                            select
                            value={limit}
                            margin='dense'
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={(event) => setLimit(event.target.value)}
                        >
                            <MenuItem  value="10">10</MenuItem>
                            <MenuItem  value="20">20</MenuItem>
                            <MenuItem  value="30">30</MenuItem>
                            <MenuItem  value="50">50</MenuItem>
                            <MenuItem  value="100">100</MenuItem>
                            <MenuItem  value="200">200</MenuItem>
                        </TextField>
                    </Grid>
                    <Grid item xs={8} sm={6}>

                        <ReactPaginate
                            previousLabel={'<'}
                            nextLabel={'>'}
                            breakLabel={'...'}
                            pageCount={pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={(selectedItem) => setPage(selectedItem.selected + 1)}
                            containerClassName={'pagination'}
                            activeClassName={'active'}
                        />
                    </Grid>
                </Grid>
            </Box>
            <div style={{ display: 'flex', direction: 'row', justifyContent: 'flex-end'}}>
                {Boolean(authReducer.user.permissions.user.store_users_admin) && <UserCreate reload={() => handleRequest()}/>}
                <Tooltip title="سینک" onClick={() => handleRequest()}>
                    <IconButton>
                        <SyncIcon />
                    </IconButton>
                </Tooltip>
            </div>
            <>
                <div style={{ overflowX: 'auto'}}>
                    <table className='table'>
                        <thead>
                        <tr>
                            <th onClick={() => { setSortField('id'); setSortType(sort_type === 'desc' ? 'asc' : 'desc') }}>#&nbsp;{ sort_field === 'id' ? (sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                            <th onClick={() => { setSortField('name'); setSortType(sort_type === 'desc' ? 'asc' : 'desc') }}>نام &nbsp;{sort_field === 'name' ? (sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                            <th onClick={() => { setSortField('role_id'); setSortType(sort_type === 'desc' ? 'asc' : 'desc') }}>نقش&nbsp;{sort_field === 'role_id' ? (sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                            <th onClick={() => { setSortField('mobile'); setSortType(sort_type === 'desc' ? 'asc' : 'desc') }}>موبایل&nbsp;{sort_field === 'mobile' ? (sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                            <th onClick={() => { setSortField('username'); setSortType(sort_type === 'desc' ? 'asc' : 'desc') }}>نام کاربری&nbsp;{sort_field === 'email' ? (sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                            <th onClick={() => { setSortField('created_at'); setSortType(sort_type === 'desc' ? 'asc' : 'desc') }}>تاریخ ثبت نام&nbsp;{sort_field === 'created_at' ? (sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                            <th onClick={() => { setSortField('status'); setSortType(sort_type === 'desc' ? 'asc' : 'desc') }}>وضعیت&nbsp;{sort_field === 'status' ? (sort_type === 'desc' ? <ArrowDownwardIcon/> : <ArrowUpwardIcon/>) : <SortIcon/>}</th>
                            <th>عملیات</th>
                        </tr>
                        </thead>
                        <tbody>
                        {users.users.data && users.users.data.map((user, index) => {
                            return(
                                <tr key={user.id}>
                                    <td>{user.id}</td>
                                    <td>{`${user.name ?? '-'} ${user.family ?? '-'}`}</td>
                                    <td>{user.role ? user.role.title ? user.role.title: user.role.key : '-'}</td>
                                    <td>{user.mobile}</td>
                                    <td>{user.username}</td>
                                    <td style={{ direction: 'ltr'}}>{moment(user.created_at).locale('fa').format('jYYYY/jMM/jDD HH:mm:ss')}</td>
                                    <td>
                                        <Tooltip title="وضعیت">
                                            <Chip size={"small"} variant={"outlined"} color={user.status ? "primary": "secondary"}  label={user.status ? 'فعال' : 'بلاک'} clickable={true} onClick={() => handleChangeStatue(user.id)} />
                                        </Tooltip>
                                    </td>
                                    <td style={{ display:'flex', 'direction': 'row', justifyContent: 'center'}}>
                                        {Boolean(authReducer.user.permissions.user.update_user_admin) && <UserEdit user={user.id} reload={() => handleRequest()} />}
                                        {Boolean(authReducer.user.permissions.user.update_user_password_admin) && <UserPassword user={user.id}/>}
                                    </td>
                                </tr>
                            );
                        })}
                        </tbody>
                    </table>
                </div>
                <ReactPaginate
                    previousLabel={'<'}
                    nextLabel={'>'}
                    breakLabel={'...'}
                    pageCount={pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={(selectedItem) => setPage(selectedItem.selected + 1)}
                    containerClassName={'pagination'}
                    activeClassName={'active'}
                />
            </>
        </Container>

    );
}


const mapStateToProps = state => ({
    users: state.userReducer,
    roles: state.roleReducer,
    authReducer: state.authReducer

});

const mapDispatchToProps = (dispatch) => ({
    fetchRoles: () => {
        dispatch(roleAction.fetchRoles())
    },
    fetchUsers: (object) => {
        dispatch(userAction.fetchUsers(object))
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(Users)
